// Entry point for the build script
import "@hotwired/turbo-rails"
import "./controllers"
import "flowbite"
import debounce from "lodash/debounce"
import "./faq"

// Make lodash/debounce available globally
window.debounce = debounce;
